// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2622":"30309803","5705":"c8223b8a","6498":"7021ef0e","6785":"c8223b8a"}[chunkId] + ".chunk.css";
};